import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'

const BenefitsSection = () => {
  const benefits = [
    {
      images: ['/images/eyesR.png', '/images/eyesL.png'],
      title: 'Stimulation Visuelle Haute Précision',
      description: 'Point oscillant fluide, ajustement instantané via raccourcis, confort visuel avec couleurs personnalisables.'
    },
    {
      images: ['/images/sound1.png', '/images/sound2.png'],
      title: 'Stimulation Auditive Synchronisée',
      description: 'Un son bilatéral (gauche/droite) parfaitement calé sur le mouvement du point, pour une stimulation cohérente et enveloppante.'
    },
    {
      images: ['/images/joyconR.png', '/images/joyconL.png'],
      title: 'Stimulation Kinesthésique',
      description: 'Utilise les vibrations HD des Joy-Cons de Nintendo. Économique, accessible, sans fil (Bluetooth) et performant.'
    }
  ]

  const [currentImageIndex, setCurrentImageIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2)
    }, 500) // Réduit le temps d'intervalle à 500ms pour une animation plus rapide
    return () => clearInterval(interval)
  }, [])

  return (
    <section className="section-padding bg-slate-50">
      <div className="container-max">
        <motion.div 
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Trois types de stimulation, une expérience complète
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Adaptez-vous à chaque patient avec notre gamme complète de stimulations bilatérales
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="mb-4">
                {benefit.images.length > 1 ? (
                  <motion.img 
                    src={benefit.images[currentImageIndex % benefit.images.length]} 
                    alt={benefit.title} 
                    className="w-50 h-50 mx-auto"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: index * 0.2 }}
                    viewport={{ once: true }}
                  />
                ) : (
                  <img src={benefit.images[0]} alt={benefit.title} className="w-50 h-50 mx-auto" />
                )}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default BenefitsSection 